module.exports = __webpack_public_path__ + "static/img/contentRightImg1.bc6e324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg1.png
// module id = zOBd
// module chunks = 2